import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { Survey } from "@/modules/surveys/viewmodels/Survey";

export const state = {
  surveys: [],
};

export const getters = Object.assign(
  {
    surveys: (state) => {
      return state.surveys;
    },
    survey: (state) => (Id) => {
      return state.surveys.find((e) => e.id === Id);
    },
  },
  new BaseApiGetters(process.env.VUE_APP_BASE_URL + "/api/surveys", Survey, {
    AfterGetAll: (name, data) => {
      data.forEach((e) => {
        let foundElement = state.surveys.find((a) => a.id === e.id);
        if (foundElement) {
          Object.assign(foundElement, e);
        } else {
          state.surveys.push(e);
        }
      });
      return data;
    },
    AfterShow: (name, data) => {
      let el = state.surveys.find((e) => e.id === data.id);
      if (el) {
        el = data;
      } else {
        state.surveys.push(data);
      }
      return data;
    },
    AfterDestroy: (name, data) => {
      let elementIndex = state.surveys.findIndex((e) => e.id === data);

      if (elementIndex !== null) {
        state.surveys.splice(elementIndex, 1);
      }

      return data;
    },
  })
);

// mutations
export const mutations = {
  setVoted: (state, SurveyId) => {
    let el = state.surveys.find((e) => e.id === SurveyId);
    el.voted = true;
  },
};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/surveys",
  [],
  {
    async setVoted({ commit }, SurveyId) {
      commit("setVoted", SurveyId);
    },
  }
);
